<template>
  <div class="customer-service" @click="openService" @mouseenter="showFull" @mouseleave="hideHalf" v-if="!isXadtrackPage">
    <div class="icon-wrapper" :class="{ 'show-full': isFullVisible }">
      <svg-icon icon-class="ai" />
    </div>
    <div class="tooltip" v-if="isFullVisible">
      我是客服助手
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerService',
  data() {
    return {
      isFullVisible: false
    }
  },
  computed: {
    isXadtrackPage() {
      return window.location.href.includes('xadtrack');
    }
  },
  methods: {
    showFull() {
      this.isFullVisible = true
    },
    hideHalf() {
      this.isFullVisible = false
    },
    openService() {
      // 计算屏幕中心位置
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const windowWidth = 1400;
      const windowHeight = 900;
      
      const left = Math.floor((screenWidth - windowWidth) / 2);
      const top = Math.floor((screenHeight - windowHeight) / 2);
      const features = [
            `width=${windowWidth}`,
            `height=${windowHeight}`,
            `left=${left}`,
            `top=${top}`,
            'menubar=no',        // 不显示菜单栏
            'toolbar=no',        // 不显示工具栏
            'location=yes',      // 显示地址栏（安全考虑）
            'status=no',         // 不显示状态栏
            'resizable=yes',     // 允许调整大小
            'scrollbars=yes',    // 显示滚动条
            'noopener=yes',      // 安全设置，防止新窗口访问原窗口
            'noreferrer=yes'     // 安全设置，不发送referrer
      ].join(',');
      window.open('https://chat.qianhaiyunling.com/client?clientId=1747941862162960384', '_blank', features)
    }
  }
}
</script>

<style scoped>
.customer-service {
  position: fixed;
  bottom: 50px;
  right: 0;
  z-index: 9999;
  cursor: pointer;
}

.icon-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transform: translateX(40px);
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper.show-full {
  transform: translateX(0);
}

.icon-wrapper .svg-icon {
  width: 60px;
  height: 60px;
}

.tooltip {
  position: absolute;
  bottom: 70px;
  right: 10px;
  background-color: #000;
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10000;
  animation: fadeIn 0.3s ease;
}

.tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  right: 15px;
  border-width: 6px;
  border-style: solid;
  border-color: #000 transparent transparent transparent;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>